import React, { useState, useEffect, useCallback } from 'react';

// Iconos de Lucide como SVG inline
const IconoBuscar = (props) => <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"></circle><path d="m21 21-4.3-4.3"></path></svg>;
const IconoMas = (props) => <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"></path><path d="M12 5v14"></path></svg>;
const IconoEditar = (props) => <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 3a2.85 2.85 0 0 1 4 4L7.5 20.5 2 22l1.5-5.5Z"></path><path d="M15 5l4 4"></path></svg>;
const IconoImprimir = (props) => <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path><path d="M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6"></path><rect width="6" height="4" x="9" y="14" rx="1"></rect></svg>;
const IconoEliminar = (props) => <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 6h18"></path><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path><line x1="10" x2="10" y1="11" y2="17"></line><line x1="14" x2="14" y1="11" y2="17"></line></svg>;


// Nombre de la clave que usaremos en el localStorage para recetas
const STORAGE_KEY = 'adminRecetasData';

// Estructura de datos inicial si no hay nada en localStorage
const initialRecetasData = [
    { 
        id: 1, 
        paciente: 'Ana García', 
        medico: 'Dr. Lisset', 
        fecha_emision: '2025-11-20', 
        contenido: "Paracetamol 500mg - Tomar 1 tableta cada 8 horas por 5 días.\nReposo absoluto."
    },
    { 
        id: 2, 
        paciente: 'Roberto Pérez', 
        medico: 'Dr. Javier', 
        fecha_emision: '2025-11-21', 
        contenido: "Amoxicilina 250mg/5ml - Tomar 5ml cada 12 horas por 7 días."
    },
    { 
        id: 3, 
        paciente: 'Sofía Martínez', 
        medico: 'Dr. Lisset', 
        fecha_emision: '2025-11-22', 
        contenido: "Loratadina 10mg - Tomar 1 tableta cada 24 horas por 3 días."
    }
];

const initialReceta = {
    id: null, 
    paciente: '', 
    medico: '', 
    fecha_emision: new Date().toISOString().substring(0, 10),
    contenido: ''
};

// --- Componente de la Plantilla de Impresión (Solo se muestra en el diálogo de impresión) ---
const PrintRecetaTemplate = ({ receta }) => (
    // IMPORTANTE: Este div tiene la clase 'print-only' y 'print-receta-container' para el CSS de impresión.
    <div className="print-only print-receta-container">
        <header className="receta-header">
            <div className="receta-title">CLÍNICA MÉDICA VITAL</div>
            <p className="text-xs">Servicios de Consulta General | Tel: (555) 555-0101</p>
        </header>
        
        <section className="info-grid-print">
            <div className="info-item">
                <strong>Paciente:</strong> {receta.paciente}
            </div>
            <div className="info-item">
                <strong>Fecha de Emisión:</strong> {receta.fecha_emision}
            </div>
            <div className="info-item">
                <strong>Médico Emisor:</strong> {receta.medico}
            </div>
        </section>
        
        <section className="receta-content-print">
            <h4 className="text-lg font-bold mb-2 underline">PRESCRIPCIÓN:</h4>
            {/* Usamos white-space: pre-wrap para respetar los saltos de línea del textarea */}
            <p style={{ whiteSpace: 'pre-wrap', lineHeight: '1.6' }}>{receta.contenido}</p>
        </section>

        <footer className="receta-footer-print">
            <div className="signature-line"></div>
            <p>Firma y Sello del Médico</p>
            <p className="mt-4 text-xs">--- Documento de uso exclusivo del paciente ---</p>
        </footer>
    </div>
);


export default function RecetasView() {
    // 1. Cargar datos del localStorage o usar los iniciales
    const [recetas, setRecetas] = useState(() => {
        try {
            const storedData = localStorage.getItem(STORAGE_KEY);
            return storedData ? JSON.parse(storedData) : initialRecetasData;
        } catch (error) {
            console.error("Error cargando datos de localStorage para recetas:", error);
            // Fallback: usar los datos iniciales si localStorage falla
            return initialRecetasData;
        }
    });

    // 2. Usar useEffect para guardar los datos cada vez que 'recetas' cambie
    useEffect(() => {
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(recetas));
        } catch (error) {
            console.error("Error guardando datos de recetas en localStorage:", error);
        }
    }, [recetas]); 

    // Estados para la Interfaz
    const [message, setMessage] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [currentReceta, setCurrentReceta] = useState(initialReceta);
    const [isEditing, setIsEditing] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    // --- Funciones de Utilidad y Notificación ---
    const showMessage = useCallback((msg, type = 'success') => {
        setMessage({ msg, type });
        // Mantenemos el mensaje de impresión más tiempo para que el usuario lo lea
        const duration = type === 'info' ? 5000 : 3000;
        setTimeout(() => setMessage(''), duration);
    }, [setMessage]);

    const closeModal = useCallback(() => {
        setIsModalOpen(false);
        setIsEditing(false);
        setCurrentReceta(initialReceta);
    }, []);

    // --- Lógica de Impresión (Usando la función nativa del navegador) ---
    const handlePrint = useCallback(() => {
        // Al llamar a window.print(), el media query @media print hace que solo se vea la plantilla.
        window.print();
        showMessage("Abre el diálogo de impresión y selecciona 'Guardar como PDF' para descargar.", 'info');
    }, [showMessage]);

    // --- Lógica del CRUD ---

    const handleCreate = useCallback(() => {
        setIsEditing(false);
        // Usar la fecha por defecto de initialReceta
        setCurrentReceta(initialReceta);
        setIsModalOpen(true);
    }, []);

    const handleEdit = useCallback((receta) => {
        setIsEditing(true);
        setCurrentReceta(receta); 
        setIsModalOpen(true);
    }, []);

    const handleDelete = useCallback((receta) => {
        setCurrentReceta(receta);
        setIsDeleteModalOpen(true);
    }, []);

    const confirmDelete = useCallback(() => {
        setRecetas(prevRecetas => prevRecetas.filter(r => r.id !== currentReceta.id));
        showMessage(`[ELIMINADA] Receta de ${currentReceta.paciente} eliminada permanentemente.`, 'success');
        setIsDeleteModalOpen(false);
        setCurrentReceta(initialReceta);
    }, [currentReceta, showMessage]);

    const handleFormChange = useCallback((e) => {
        const { name, value } = e.target;
        setCurrentReceta(prev => ({ ...prev, [name]: value }));
    }, []);

    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        
        let updatedReceta;

        if (isEditing && currentReceta.id) {
            // Edición: Actualizar en la lista
            setRecetas(prevRecetas => prevRecetas.map(r => r.id === currentReceta.id ? currentReceta : r));
            updatedReceta = currentReceta;
            showMessage(`[ACTUALIZADA] Receta para ${currentReceta.paciente} modificada con éxito.`, 'success');
        } else {
            // Creación: Generar el nuevo ID correctamente
            setRecetas(prevRecetas => {
                const maxId = prevRecetas.length > 0 ? Math.max(...prevRecetas.map(r => r.id)) : 0;
                const newId = maxId + 1;
                updatedReceta = { ...currentReceta, id: newId };
                return [...prevRecetas, updatedReceta];
            });
            
            // Usamos un setTimeout para asegurar que updatedReceta tenga el ID después del setRecetas asíncrono
            // Aunque en este caso, la simple asignación de updatedReceta funciona por la captura de la función
            setCurrentReceta(updatedReceta); 
            
            showMessage(`[CREADA] Receta para ${currentReceta.paciente} emitida con éxito.`, 'success');
        }

        // Si creamos o editamos, pasamos a modo edición para poder imprimir
        setIsEditing(true);
        
        // Cierre suave del modal si no estamos imprimiendo inmediatamente (opcional)
        // Ya que el requerimiento es poder imprimir, mantenemos el modal abierto y en modo edición.
    }, [isEditing, currentReceta, showMessage]);
    
    // --- Lógica de Filtrado ---
    const filteredRecetas = recetas.filter(receta => {
        const lowerCaseSearch = searchTerm.toLowerCase();
        
        // Combina los campos relevantes para una búsqueda amplia
        return (
            receta.paciente.toLowerCase().includes(lowerCaseSearch) ||
            receta.medico.toLowerCase().includes(lowerCaseSearch) ||
            receta.contenido.toLowerCase().includes(lowerCaseSearch)
        );
    });


    return (
        // El estilo global para la impresión va aquí, en el head invisible.
        <>
            {/* Estilos para impresión (media print) - ESENCIAL PARA FORMATO A4 */}
            <style>{`
                @media print {
                    /* --- INICIO DE LA CORRECCIÓN CLAVE --- */
                    /* 1. Ocultar absolutamente todo en la página por defecto */
                    body * {
                        visibility: hidden !important;
                        background: none !important;
                    }
                    
                    /* 2. El contenedor de la plantilla de impresión es la excepción. Mostrarlo a él y a sus hijos. */
                    .print-only, .print-only * {
                        visibility: visible !important;
                        display: block !important; 
                        position: static !important; /* Volver a flujo normal de impresión */
                        background-color: white !important; /* Asegurar fondo blanco */
                        color: black !important;
                    }

                    /* 3. Posicionar la plantilla para que cubra toda la página */
                    .print-receta-container {
                        position: absolute !important;
                        left: 0 !important;
                        top: 0 !important;
                        
                        /* Estilos de formato de documento A4 */
                        width: 210mm; /* Ancho A4 */
                        min-height: 297mm; /* Altura A4 */
                        padding: 20mm; /* Márgenes estándar */
                        font-family: 'Inter', sans-serif;
                        margin: 0 auto;
                        box-shadow: none;
                    }
                    /* --- FIN DE LA CORRECCIÓN CLAVE --- */
                    
                    .receta-header {
                        border-bottom: 2px solid #1f2937;
                        padding-bottom: 15px;
                        margin-bottom: 25px;
                        text-align: center;
                    }
                    .receta-title {
                        font-size: 26pt; /* Título más grande */
                        font-weight: 700;
                        color: #1f2937; 
                    }
                    .info-grid-print {
                        display: flex;
                        justify-content: space-between;
                        margin-bottom: 35px; /* Más espacio */
                        font-size: 11pt;
                        line-height: 1.5;
                        border: 1px solid #ccc; /* Pequeño borde para la información */
                        padding: 10px;
                        border-radius: 4px;
                    }
                    .receta-content-print {
                        border: 2px solid #065F46; /* Borde verde oscuro */
                        background-color: #F0FFF4; /* Fondo muy claro */
                        padding: 25px;
                        min-height: 120mm;
                        font-size: 13pt; /* Letra más legible */
                        line-height: 1.8;
                    }
                    .receta-footer-print {
                        text-align: center;
                        margin-top: 60px;
                        font-size: 10pt;
                    }
                    .signature-line {
                        border-top: 1px solid #1f2937; 
                        width: 200px; /* Línea de firma más ancha */
                        margin: 0 auto 5px auto;
                    }
                }
            `}</style>

            {/* Contenedor principal de la aplicación */}
            <div id="app" className="p-4 md:p-8 max-w-7xl mx-auto font-sans min-h-screen">

                {/* Notificación Visual Flotante */}
                {message && (
                    <div className="fixed top-0 left-1/2 transform -translate-x-1/2 mt-4 z-50">
                        <div className={`${message.type === 'success' ? 'bg-green-500' : (message.type === 'info' ? 'bg-blue-500' : 'bg-red-500')} text-white font-bold py-2 px-4 rounded-lg shadow-xl transition duration-500`}>
                            {message.msg}
                        </div>
                    </div>
                )}

                <h1 className="text-3xl font-extrabold text-gray-900 mb-6 border-b-4 border-indigo-600 pb-2 flex items-center">
                    <IconoImprimir className="w-8 h-8 mr-3 text-indigo-600"/>
                    Gestión de Recetas Médicas
                </h1>

                {/* Controles: Botón para crear y Barra de Búsqueda */}
                <div className="flex flex-col sm:flex-row justify-between items-center mb-8 gap-4">
                    <button
                        onClick={handleCreate} 
                        className="flex-shrink-0 w-full sm:w-auto items-center px-6 py-3 bg-indigo-600 text-white font-bold rounded-xl shadow-lg hover:bg-indigo-700 transition duration-150 transform hover:scale-[1.02]"
                    >
                        <IconoMas className="h-5 w-5 mr-2 inline-block"/>
                        Emitir Nueva Receta
                    </button>
                    
                    {/* BARRA DE BÚSQUEDA */}
                    <div className="relative w-full sm:max-w-md">
                        <input
                            type="text"
                            placeholder="Buscar por Paciente, Médico o Contenido..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="w-full py-3 pl-12 pr-4 border border-gray-300 rounded-xl shadow-inner focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition duration-150"
                        />
                        <IconoBuscar className="absolute left-4 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400"/>
                    </div>
                </div>

                <h2 className="text-xl font-semibold text-gray-700 mb-4 border-b pb-1">Recetas Emitidas ({filteredRecetas.length})</h2>

                {/* Tabla de Recetas */}
                <div className="overflow-x-auto bg-white shadow-2xl rounded-xl">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-100">
                            <tr>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">ID</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">Fecha</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">Paciente</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider hidden sm:table-cell">Médico</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider hidden md:table-cell">Contenido (Extracto)</th>
                                <th className="px-6 py-3 text-right text-xs font-medium text-gray-600 uppercase tracking-wider">Acciones</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {filteredRecetas.length === 0 ? (
                                <tr>
                                    <td colSpan="6" className="px-6 py-8 text-center text-sm text-gray-500 italic">
                                        {searchTerm ? "No se encontraron recetas que coincidan con la búsqueda." : "No hay recetas registradas."}
                                    </td>
                                </tr>
                            ) : (
                                filteredRecetas.map((receta) => (
                                    <tr key={receta.id} className="hover:bg-indigo-50 transition duration-150">
                                        <td className="px-6 py-4 whitespace-nowrap text-sm font-bold text-indigo-700">{receta.id}</td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{receta.fecha_emision}</td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{receta.paciente}</td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600 hidden sm:table-cell">{receta.medico}</td>
                                        <td className="px-6 py-4 max-w-xs overflow-hidden text-ellipsis text-sm text-gray-500 hidden md:table-cell">
                                            {receta.contenido.substring(0, 50)}{receta.contenido.length > 50 ? '...' : ''}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                            <div className="flex justify-end space-x-3">
                                                <button
                                                    onClick={() => handleEdit(receta)} 
                                                    className="p-2 text-blue-600 hover:text-blue-900 hover:bg-blue-100 rounded-full transition duration-150"
                                                    title="Editar"
                                                >
                                                    <IconoEditar className="w-5 h-5"/>
                                                </button>
                                                <button
                                                    onClick={() => handleDelete(receta)} 
                                                    className="p-2 text-red-600 hover:text-red-900 hover:bg-red-100 rounded-full transition duration-150"
                                                    title="Eliminar"
                                                >
                                                    <IconoEliminar className="w-5 h-5"/>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>

                {/* MODAL de CREAR/EDITAR */}
                {isModalOpen && (
                    <div className="fixed inset-0 bg-gray-600 bg-opacity-75 flex items-center justify-center z-50 p-4">
                        <div className="bg-white rounded-xl shadow-2xl w-full max-w-3xl p-8 max-h-[90vh] overflow-y-auto">
                            <h3 className="text-2xl font-bold mb-6 text-gray-900 border-b pb-2">
                                {currentReceta.id ? 'Editar Receta' : 'Emitir Nueva Receta'}
                            </h3>
                            
                            <form onSubmit={handleSubmit}>
                                
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                                    
                                    <label className="block">
                                        <span className="text-gray-700 font-medium">Paciente:</span>
                                        <input
                                            type="text" name="paciente" required value={currentReceta.paciente}
                                            onChange={handleFormChange}
                                            className="mt-1 block w-full rounded-lg border-gray-300 shadow-sm p-2 focus:ring-indigo-500 focus:border-indigo-500"
                                            placeholder="Nombre del Paciente"
                                        />
                                    </label>
                                    
                                    <label className="block">
                                        <span className="text-gray-700 font-medium">Médico Emisor:</span>
                                        <input
                                            type="text" name="medico" required value={currentReceta.medico}
                                            onChange={handleFormChange}
                                            className="mt-1 block w-full rounded-lg border-gray-300 shadow-sm p-2 focus:ring-indigo-500 focus:border-indigo-500"
                                            placeholder="Nombre del Médico"
                                        />
                                    </label>

                                    <label className="block">
                                        <span className="text-gray-700 font-medium">Fecha de Emisión:</span>
                                        <input
                                            type="date" name="fecha_emision" required value={currentReceta.fecha_emision}
                                            onChange={handleFormChange}
                                            className="mt-1 block w-full rounded-lg border-gray-300 shadow-sm p-2 focus:ring-indigo-500 focus:border-indigo-500"
                                        />
                                    </label>
                                </div>

                                <div className="mb-8">
                                    <label className="block">
                                        <span className="text-gray-700 font-medium">Contenido de la Receta (Medicamentos y Dosis):</span>
                                        <textarea
                                            name="contenido" required rows="8" value={currentReceta.contenido}
                                            onChange={handleFormChange}
                                            className="mt-1 block w-full rounded-lg border-gray-300 shadow-sm p-3 focus:ring-indigo-500 focus:border-indigo-500"
                                            placeholder="Ejemplo: Ibuprofeno 600mg - Tomar 1 cada 12 horas. Próxima revisión en 7 días."
                                        />
                                    </label>
                                </div>

                                {/* Botones de acción */}
                                <div className="flex justify-between items-center pt-4 border-t">
                                    {/* Botón de Impresión (Solo aparece si ya tiene ID y está guardada) */}
                                    {currentReceta.id && isEditing && (
                                        <button type="button" onClick={handlePrint}
                                            className="bg-red-600 text-white font-bold py-2 px-4 rounded-lg shadow-md hover:bg-red-700 transition duration-150 flex items-center transform hover:scale-[1.05]">
                                            <IconoImprimir className="h-5 w-5 mr-2"/>
                                            Imprimir Receta (PDF)
                                        </button>
                                    )}
                                    
                                    <div className="flex space-x-4 ml-auto">
                                        <button type="button" onClick={closeModal}
                                            className="bg-gray-300 text-gray-800 font-bold py-2 px-4 rounded-lg hover:bg-gray-400 transition duration-150">
                                            {currentReceta.id ? 'Cerrar' : 'Cancelar'}
                                        </button>
                                        <button type="submit"
                                            className="bg-indigo-600 text-white font-bold py-2 px-4 rounded-lg shadow-md hover:bg-indigo-700 transition duration-150">
                                            {currentReceta.id ? 'Guardar Cambios' : 'Emitir Receta'}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                )}

                {/* MODAL de CONFIRMACIÓN de ELIMINACIÓN */}
                {isDeleteModalOpen && (
                    <div className="fixed inset-0 bg-gray-600 bg-opacity-75 flex items-center justify-center z-50 p-4">
                        <div className="bg-white rounded-xl shadow-2xl w-full max-w-sm p-6 text-center">
                            <IconoEliminar className="w-10 h-10 text-red-500 mx-auto mb-4"/>
                            <h3 className="text-xl font-bold mb-4 text-gray-900">Confirmar Eliminación</h3>
                            <p className="text-gray-700 mb-6">
                                ¿Estás seguro de que quieres eliminar la receta para <strong className='font-semibold'>{currentReceta.paciente}</strong>? Esta acción es permanente.
                            </p>
                            
                            <div className="flex justify-center space-x-4">
                                <button type="button" onClick={() => setIsDeleteModalOpen(false)}
                                    className="bg-gray-300 text-gray-800 font-bold py-2 px-4 rounded-lg hover:bg-gray-400 transition duration-150">
                                    Cancelar
                                </button>
                                <button type="button" onClick={confirmDelete}
                                    className="bg-red-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-red-700 transition duration-150">
                                    Sí, Eliminar
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* Plantilla de Impresión - Oculta por defecto, solo visible con @media print */}
            {/* Solo renderizamos la plantilla si el modal está abierto y tenemos una receta guardada para imprimir */}
            {isModalOpen && currentReceta.id && <PrintRecetaTemplate receta={currentReceta} />}
        </>
    );
}